import { render, staticRenderFns } from "./confirmDataPeserta.vue?vue&type=template&id=3a881415&"
import script from "./confirmDataPeserta.vue?vue&type=script&lang=js&"
export * from "./confirmDataPeserta.vue?vue&type=script&lang=js&"
import style0 from "./confirmDataPeserta.vue?vue&type=style&index=0&id=3a881415&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports